import { Icon, isIconName, type IconName } from '@gftg/ui';

/**
 * `home_tiles.icon_key` is organizer-owned free text, so the mapping from a key to a glyph
 * belongs to the app. Keys that already name a brand-kit icon are used as they are; the rest
 * are translated here, and anything unknown falls back rather than leaving an empty slot.
 */
const ALIASES: Record<string, IconName> = {
  venue: 'map',
  schedule: 'star',
  directory: 'people',
  announcements: 'bell',
  donate: 'heart',
  store: 'bag',
};

export function TileIcon({
  iconKey,
  size = 22,
  className,
  fallback = 'agenda',
}: {
  iconKey: string | null;
  size?: number;
  className?: string;
  fallback?: IconName;
}) {
  const name = iconKey
    ? (ALIASES[iconKey] ?? (isIconName(iconKey) ? iconKey : fallback))
    : fallback;

  return <Icon name={name} size={size} className={className} />;
}
